export const displayNameInitialsOrEmail = (user) => {
	if (!user.firstname || !user.lastname) {
		return user.email || "UNKNOWN";
	}
	return `${user.firstname[0]}. ${user.lastname}`;
};
